import { useDripsyTheme } from '../use-dripsy-theme';
import { useBreakpointIndex } from './breakpoint-context';
export function useResponsiveValue(values) {
    const maybeContext = useDripsyTheme();
    const array = typeof values === 'function' ? values(maybeContext?.theme) : values;
    const index = useBreakpointIndex();
    return array[index >= array.length ? array.length - 1 : index];
}
//# sourceMappingURL=use-responsive-value.js.map